import { connect } from 'react-redux';
import React from 'react';
import * as valid from 'utils/validate';
import { renderKBInput, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';
import { KBFormError,
KBButton,
KBSelect } from
'components';
import * as selectors from 'app/selectors';

var SpaceSettingPrepayCard = class extends React.Component {constructor(props) {super(props);this.updateSpace = this.updateSpace.bind(this);}updateSpace(

  model) {
    const { updateCurrentSpace } = this.props;

    updateCurrentSpace(
    {
      settings: JSON.stringify({
        invoice_settings: model }) },


    {
      key: 'invoice_settings' });


  }render()

  {
    const {
      fields: { prepay_card_mchid },
      error,
      submitting,
      handleSubmit } =
    this.props;
    return (
      <form onSubmit={handleSubmit(this.updateSpace)}>
        <KBFormError err={this.props.error} />
        <div className="kb-form-container" style={{ padding: 0 }}>
          <KBFormError err={error} />
          <div className="kb-row">
            <Field name="prepay_card_mchid" component={renderKBInput}
            title="商户号"
            className="kb-form-group kb-form-c39 kb-form-alone"
            />

          </div>
          <div className="kb-row m-top">
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              保存
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const setting = props.setting || {};
  const { prepay_card_mchid = '' } = setting.invoice_settings || {};
  return {
    // input组件不展示number类型的数据？？？这里转成字符串
    initialValues: { prepay_card_mchid: String(prepay_card_mchid) } };

}

function mapDispatchToProps(dispatch) {
  return {};
}

const formConfig = {
  form: 'SpaceSettingPrepayCard',
  touchOnBlur: false };


const LEGACY_FORM_FIELDS = [
  "prepay_card_mchid"
];


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('SpaceSettingPrepayCard', LEGACY_FORM_FIELDS)(SpaceSettingPrepayCard)));
